import React from 'react'
import { Spin } from 'antd'
import styled from 'styled-components'

type Props = {
  /** en una pagina completa reserva la altura de la cabecera fija; dentro de otra pagina, no */
  fullPage?: boolean
}

/**
 * Aviso de carga: el spinner, centrado y con hueco reservado para que la pagina
 * no de un salto al llegar los datos.
 */
export const LoadingState: React.FC<Props> = ({ fullPage = true }) => (
  <Wrapper fullPage={fullPage} role="status" aria-live="polite" aria-label="Cargando">
    <Spin size="large" />
  </Wrapper>
)

const Wrapper = styled.div<{ fullPage: boolean }>`
  /* la cabecera es fija: le reservamos su altura, igual que hacen los visores */
  margin-top: ${({ fullPage }) => (fullPage ? '50px' : '0')};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 0;
  min-height: 240px;
  background-color: #fff;

  @media only screen and (min-width: 1024px) {
    margin-top: ${({ fullPage }) => (fullPage ? '100px' : '0')};
  }
`
